module.exports = __webpack_public_path__ + "static/media/rock-saddles.be0f691c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/rock-saddles.jpg
// module id = 318
// module chunks = 0